import { getTimezoneOffset } from 'date-fns-tz';

export const DAYS_IN_WEEK = 7;
export const DAYS_IN_MONTH = 31;
export const MONTHS_IN_YEAR = 12;

export const MONTH_NUMBERS = Array.from({ length: MONTHS_IN_YEAR }, (_, index) => index + 1);
export const DAY_NUMBERS = Array.from({ length: DAYS_IN_MONTH }, (_, index) => index + 1);

export const DAYS_IN_MONTH_BY_MONTH = {
  1: 31,
  2: 29,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31,
};

export const DAYS_OF_WEEK = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
};

export const DAYS_OF_WEEK_SHORT = {
  [DAYS_OF_WEEK.SUNDAY]: 'Sun',
  [DAYS_OF_WEEK.MONDAY]: 'Mon',
  [DAYS_OF_WEEK.TUESDAY]: 'Tue',
  [DAYS_OF_WEEK.WEDNESDAY]: 'Wed',
  [DAYS_OF_WEEK.THURSDAY]: 'Thu',
  [DAYS_OF_WEEK.FRIDAY]: 'Fri',
  [DAYS_OF_WEEK.SATURDAY]: 'Sat',
};

export const DAYS_OF_WEEK_SHORT_ARRAY = [
  DAYS_OF_WEEK_SHORT.SUNDAY,
  DAYS_OF_WEEK_SHORT.MONDAY,
  DAYS_OF_WEEK_SHORT.TUESDAY,
  DAYS_OF_WEEK_SHORT.WEDNESDAY,
  DAYS_OF_WEEK_SHORT.THURSDAY,
  DAYS_OF_WEEK_SHORT.FRIDAY,
  DAYS_OF_WEEK_SHORT.SATURDAY,
];

export const DAYS_OF_WEEK_SHORT_OPTIONS = [
  { id: 0, label: DAYS_OF_WEEK_SHORT.SUNDAY },
  { id: 1, label: DAYS_OF_WEEK_SHORT.MONDAY },
  { id: 2, label: DAYS_OF_WEEK_SHORT.TUESDAY },
  { id: 3, label: DAYS_OF_WEEK_SHORT.WEDNESDAY },
  { id: 4, label: DAYS_OF_WEEK_SHORT.THURSDAY },
  { id: 5, label: DAYS_OF_WEEK_SHORT.FRIDAY },
  { id: 6, label: DAYS_OF_WEEK_SHORT.SATURDAY },
];

export const MONTHS_OF_YEAR = {
  JANUARY: 'JANUARY',
  FEBRUARY: 'FEBRUARY',
  MARCH: 'MARCH',
  APRIL: 'APRIL',
  MAY: 'MAY',
  JUNE: 'JUNE',
  JULY: 'JULY',
  AUGUST: 'AUGUST',
  SEPTEMBER: 'SEPTEMBER',
  OCTOBER: 'OCTOBER',
  NOVEMBER: 'NOVEMBER',
  DECEMBER: 'DECEMBER',
};

export const TIMEZONES = Intl.supportedValuesOf('timeZone');

const date = new Date();

const optionsWithOffset = TIMEZONES.map(tz => {
  const offset = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'longOffset'
  }).format(date).split(' ').pop();

  const city = tz.split('/').pop().replace(/_/g, ' ');

  return {
    value: tz,
    label: `(${offset}) ${city}`,
    offsetValue: getTimezoneOffset(tz, date)
  };
});

export const TIMEZONE_OPTIONS = optionsWithOffset.sort((a, b) => {
  if (a.offsetValue !== b.offsetValue) {
    return a.offsetValue - b.offsetValue;
  }
  return a.label.localeCompare(b.label);
});

export const START_OF_WEEK_OPTIONS = [
  { value: DAYS_OF_WEEK.SUNDAY, label: 'Sunday' },
  { value: DAYS_OF_WEEK.MONDAY, label: 'Monday' },
  { value: DAYS_OF_WEEK.SATURDAY, label: 'Saturday' },
];

export const TIME_FORMATS = {
  H12: '12h',
  H24: '24h'
};

export const TIME_PATTERNS = {
  H12: 'h:mm a',
  H24: 'HH:mm'
};

export const TIME_FORMATS_OPTIONS = [
  { value: TIME_FORMATS.H12, label: '12h' },
  { value: TIME_FORMATS.H24, label: '24h' },
];

export const DATE_FORMATS = {
  MM_DD_YYYY: 'MM-DD-YYYY',
  DD_MM_YYYY: 'DD-MM-YYYY',
  YYYY_MM_DD: 'YYYY-MM-DD'
};

export const DATE_PATTERNS = {
  [DATE_FORMATS.MM_DD_YYYY]: 'MM/dd/yyyy',
  [DATE_FORMATS.DD_MM_YYYY]: 'dd/MM/yyyy',
  [DATE_FORMATS.YYYY_MM_DD]: 'yyyy/MM/dd',
};

export const DATE_FORMATS_OPTIONS = [
  { value: DATE_FORMATS.MM_DD_YYYY, label: 'MM-DD-YYYY' },
  { value: DATE_FORMATS.DD_MM_YYYY, label: 'DD-MM-YYYY' },
  { value: DATE_FORMATS.YYYY_MM_DD, label: 'YYYY-MM-DD' },
];
